import React from "react";
import { useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { Col, Container, Image, Placeholder, Row } from "react-bootstrap";
import { useAppContext, useColorMatchContext } from "../../context";
import imgFolder from "../../assets/folder.svg";
import { NavLinkWithLocale } from "../../components";
import { PaletteCard } from "../index";
import { usePalette } from "../../utils";
import style from "./UserDashboard.module.css";

const UserDashboard = () => {
  const navigate = useNavigate();
  const { i18n, t } = useTranslation();
  const { user, dispatch } = useAppContext();
  const { setColormatch } = useColorMatchContext();
  const { data, isLoading } = usePalette(user?.email, "desc");

  const handleEditPalette = async (palette) => {
    // Función para convertir una URL de imagen a un objeto File
    const convertURLToFile = async (imageURL, imageName) => {
      const response = await fetch(imageURL);
      const blob = await response.blob();
      const file = new File([blob], imageName, { type: blob.type });
      return file;
    };

    // Convertir todas las imágenes en archivos "File"
    const imageFiles = await Promise.all(
      palette.images.map(async (image) => {
        const { imageURL, imageName } = image;
        return await convertURLToFile(imageURL, imageName);
      })
    );

    // Setear las imágenes y colores en el estado
    setColormatch(palette.colors);
    imageFiles.forEach((file) => {
      dispatch({ type: "ADD_IMAGE", payload: file });
    });
    navigate(`/${i18n.language}/colormatch/${palette.id}`);
    /*  navigate(`/colormatch/${palette.id}`); */
  };

  return (
    <Container>
      <Row className="mt-5 justify-content-center">
        <Col xs="auto">
          <h1 className={style.title}>
            Welcome Back,{" "}
            {!user ? (
              <Placeholder animation="glow">
                <Placeholder
                  xs={10}
                  size="sm"
                  style={{ borderRadius: "10px" }}
                />
              </Placeholder>
            ) : (
              user.name
            )}
            .
          </h1>
        </Col>
        <Col xs={12}>
          <Row className="mt-3 justify-content-center">
            <Col xs="auto">
              <p className={style.optionsText}>
                What are you working on today?
              </p>
            </Col>
          </Row>
          <Row className="mt-2 justify-content-center">
            <Col xs="auto" className={style.btnMatchBg}>
              <NavLinkWithLocale className={style.btnTool} to="/colormatch">
                {t("Match Colors")}
              </NavLinkWithLocale>
            </Col>
            <Col xs="auto" className={style.btnSearchBg}>
              <NavLinkWithLocale className={style.btnTool} to="/search">
                {t("Search Balloons")}
              </NavLinkWithLocale>
            </Col>
          </Row>
        </Col>
      </Row>
      <Row className="mt-5">
        <Col>
          <h2 className={style.subtitle}>Recent Palettes</h2>
        </Col>
        <Col xs={12}>
          <Row
            className={`gx-1 gy-5 gx-sm-5 gy-sm-5 justify-content-start ${style.recentPalettesContainer}`}
          >
            {!isLoading && data?.length > 0 ? (
              data.map((palette, index) => (
                <Col key={index} md={3} sm={6} xs={6}>
                  <PaletteCard
                    palette={palette}
                    handleEditPalette={handleEditPalette}
                    recentPalettes={true}
                  />
                </Col>
              ))
            ) : (
              <Col
                xs={12}
                className="d-flex flex-column align-items-center justify-content-center "
              >
                <Image src={imgFolder} width="20%" />
                <p className={style.optionsText}>
                  You do not have any saved palettes yet.
                </p>
              </Col>
            )}
          </Row>
        </Col>
      </Row>
    </Container>
  );
};

export default UserDashboard;
